// extracted by mini-css-extract-plugin
export default {"search_bar":"style_search_bar__Abgb7","profile_btn":"style_profile_btn__KKs0u"};